import {AfterViewInit, Component, HostBinding, OnInit, TemplateRef, ViewChild, inject} from '@angular/core';
import {ClsConfig} from '../../../util/cls-config';
import { FilteringLogic, IgxStringFilteringOperand } from '@infragistics/igniteui-angular/core';
import {
  IGridEditDoneEventArgs, IGridEditEventArgs, IgxColumnComponent, IgxExcelExporterService, IgxPdfExporterService,
  IgxGridCell, IgxGridStateDirective, RowType
} from '@infragistics/igniteui-angular/grids/core';
import { IGX_GRID_DIRECTIVES, IgxGridComponent, IgxGridModule } from '@infragistics/igniteui-angular/grids/grid';
import { IgxIconComponent } from '@infragistics/igniteui-angular/icon';
import { IgxButtonDirective, IgxButtonModule, IgxFocusDirective, IgxRippleDirective, IgxRippleModule, IgxTextSelectionDirective } from '@infragistics/igniteui-angular/directives';
import {IGX_INPUT_GROUP_DIRECTIVES, IgxInputGroupComponent} from '@infragistics/igniteui-angular/input-group';
import { IGX_ACTION_STRIP_DIRECTIVES, IgxActionStripModule } from '@infragistics/igniteui-angular/action-strip';
import {MasOpcionesGridComponent} from '../../util/controles/mas-opciones-grid/mas-opciones-grid.component';
import {EnumNombresGrids} from '../../../core/models/enum/enum-nombres-grids';
import {ClsUtil} from '../../../util/cls-util';
import {ClsObjConfiguracionGrid} from '../../../clases-pu/util/cls-obj-configuracion-grid';
import {ClsObjCrudCatalogos} from '../../../clases-pu/02-catalogos/cls-obj-crud-catalogos';
import {ClsObjGenerico} from '../../../clases-pu/util/cls-obj-generico';
import {INeodataGridCell, INeodataMenu} from '../../../core/models/interfaces/generico-interface';
import {AppPresupuestosService} from '../../../core/services/app-presupuestos.service';
import {EnumMCGenerales} from '../../../core/models/enum/enum-menu-contextual';
import {EnumMasOpciones} from '../../../core/models/enum/enum-mas-opciones';
import {EnumTresPuntos} from '../../../core/models/enum/enum-tres-puntos';
import {ClsObjCopiado} from '../../../clases-pu/01-presupuesto/copiado/cls-obj-copiado';
import {DetallePegadoComponent} from '../../util/ventanas/detalle-pegado/detalle-pegado.component';
import {VtnGenericaComponent} from '../../util/ventanas/vtn-generica/vtn-generica.component';
import {FiltroGeneralModernoComponent} from '../../util/controles/filtro-general-moderno/filtro-general-moderno.component';
import {ClsObjPegado} from 'src/app/clases-pu/99-herramientas/pegado/cls-obj-pegado';
import {TranslateModule} from '@ngx-translate/core';
import {ContextMenuGenericoComponent} from '../../util/controles/context-menu-generico/context-menu-generico.component';
import {UppercaseDirective} from '../../../core/directivas/uppercase.directive';
import {FormsModule} from '@angular/forms';
import {PasteHandlerNeodataDirective} from '../../../core/directivas/paste-handler-neodata.directive';
import {ClsRegion} from 'src/app/core/models/cls-catalogos';
import {ClsColDetallePegado} from 'src/app/core/models/cls-pegado';
import {TipoMensajesService} from "../../../core/services/tipo-mensajes.service";
import {SummaryPipeNeoPipe} from "../../../core/pipes/summary-pipe-neo.pipe";
import {CrearComponenteDinamicoService} from "../../../core/services/crear-componente-dinamico.service";

@Component({
  selector: 'app-regiones',
  templateUrl: './regiones.component.html',
  styleUrls: ['./regiones.component.scss'],
  imports: [
    IgxGridModule,
    IGX_GRID_DIRECTIVES,
    TranslateModule,
    FiltroGeneralModernoComponent,
    IgxIconComponent,
    MasOpcionesGridComponent,
    PasteHandlerNeodataDirective,
    IGX_INPUT_GROUP_DIRECTIVES,
    FormsModule,
    UppercaseDirective,
    IgxTextSelectionDirective,
    IgxFocusDirective,
    IgxButtonModule,
    IgxButtonDirective,
    IgxActionStripModule,
    IGX_ACTION_STRIP_DIRECTIVES,
    IgxRippleModule,
    IgxRippleDirective,
    ContextMenuGenericoComponent,
    SummaryPipeNeoPipe,
    IgxInputGroupComponent
  ],
  providers: [SummaryPipeNeoPipe]
})
export class RegionesComponent extends ClsConfig implements OnInit, AfterViewInit {
  private infPpto = inject(AppPresupuestosService);
  private tipoMsg = inject(TipoMensajesService);
  private summaryPipe = inject(SummaryPipeNeoPipe);
  private excelExportService = inject(IgxExcelExporterService);
  private pdfExportService = inject(IgxPdfExporterService);
  private crearCompDinamico = inject(CrearComponenteDinamicoService);

  @ViewChild('gridRegion', {read: IgxGridComponent, static: true})
  public gridRegion: IgxGridComponent;
  @ViewChild('masOpcionesG', {read: MasOpcionesGridComponent, static: true})
  public masOpcionesG: MasOpcionesGridComponent;
  @ViewChild('filtroGeneral', {read: FiltroGeneralModernoComponent, static: true})
  public filtroGeneral: FiltroGeneralModernoComponent;
  public errorAlCargar: boolean;
  // ajuste de texto
  @HostBinding('class') public themesClass = 'noAjustarTexto';
  public clicked = false;

  // mostrar actionStrip
  public showActionStrip = true;
  public dataRegiones: ClsRegion[] = [];
  public activarBotones = false;
  private isAddRow: boolean;
  // clase catalogos
  public mObjCRUDCatalogos: ClsObjCrudCatalogos = new ClsObjCrudCatalogos();
  private mObjGenerico: ClsObjGenerico = new ClsObjGenerico();
  private mObjCopiado: ClsObjCopiado = new ClsObjCopiado();
  private mObjPegado: ClsObjPegado = new ClsObjPegado();
  // menucontextual
  public verContextMenu = false;
  public contextmenuX = 0;
  public contextmenuY = 0;
  public cellMenuContextaul: IgxGridCell;
  public menus: INeodataMenu[] = [];
  public lengthMenu: number;
  public subMenusOpciones: any[];
  public sizeMenu = '';

  // CONFIGGRIDS: definir cada ng-Template que tengamos en el HTML
  @ViewChild('regionHeaderTemplate', {static: true}) public regionHeaderTemplate: TemplateRef<any>;
  @ViewChild('regionEditorTemplate', {static: true}) public regionEditorTemplate: TemplateRef<any>;
  @ViewChild('descripcionRegionEditorTemplate', {static: true}) public descripcionRegionEditorTemplate: TemplateRef<any>;
  @ViewChild(IgxGridStateDirective, {static: true}) public state;
  // Grid Layout
  public mObjConfigGrids: ClsObjConfiguracionGrid = new ClsObjConfiguracionGrid();
  // ConfigGridLayout
  public optionsGridLocal = {
    cellSelection: true,
    rowSelection: false,
    filtering: false,
    advancedFiltering: true,
    paging: true,
    sorting: false,
    groupBy: true,
    columns: true,
    expansion: true,
    rowPinning: false,
    columnSelection: true
  };
  public vtnGenerico: VtnGenericaComponent;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.gridRegion.data = [];
  }

  public ngAfterViewInit() {
    // se genera la plantilla default del grid
    const stateDefault = this.state.getState(true);

    this.mObjConfigGrids.saveGridState(EnumNombresGrids.Regiones, true, stateDefault, '', this.clicked);
    const state = this.mObjConfigGrids.initGridState(EnumNombresGrids.Regiones);
    if (!ClsUtil.esNulo(state[0])) {
      this.state.setState(state[0]);
    }
    this.clicked = state[1];
    const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
    this.themesClass = result.themesClass;
    this.clicked = result.clicked;
  }

  public onColumnInit(column: IgxColumnComponent) {
    switch (column.field) {
      case 'Region':
        column.headerTemplate = this.regionHeaderTemplate;
        column.inlineEditorTemplate = this.regionEditorTemplate;
        column.cellStyles = this.cellStyles;
        break;
      case 'DescripcionRegion':
        column.inlineEditorTemplate = this.descripcionRegionEditorTemplate;
        column.summaries = this.summaryPipe.transform('filasSummary');
        break;
    }
  }

  public async cargarRegiones() {
    if (!ClsUtil.esNulo(this.infPpto.organizacion)) {
      try {
        this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.GET_CATALOGOS');
        this.mObjCRUDCatalogos.dataCatalogo = [];
        this.dataRegiones = [];
        await this.mObjCRUDCatalogos.obtenerCatalogo(0, 'ConsultarRegiones2021');
        this.mObjCRUDCatalogos.dataCatalogo.forEach(region => {
          const region2: ClsRegion = {
            IdRegion: region.Region,
            Region: region.Region,
            DescripcionRegion: region.DescripcionRegion
          };
          this.dataRegiones.push(region2);
        });
        this.gridRegion.data = this.dataRegiones;
        this.errorAlCargar = false;
        this.tipoMsg.cerrarWaitDialog();
      } catch (e) {
        this.tipoMsg.cerrarWaitDialog();
        this.tipoMsg.mostrarMsg(e.message, 'error');
        this.errorAlCargar = true;
      }
    }
  }

  public rowEditExit() {
    this.showActionStrip = true;
  }

  public rowEditEnter(evt: IGridEditEventArgs) {
    this.isAddRow = evt.isAddRow;
    this.showActionStrip = false;
  }

  public cellEditEnter(evt: IGridEditEventArgs) {
    if (!this.isAddRow) {
      if (evt.column.field === 'Region') {
        evt.cancel = true;
      }
    }
  }

  // evento que se ocupa para guardar o modificar
  public async addUpdateRegion(region: IGridEditDoneEventArgs) {
    const newValor: ClsRegion = region.newValue;
    const oldValor: ClsRegion = region.oldValue;
    if (region.isAddRow) {
      await this.agregarModificarRegion(newValor, oldValor, region.isAddRow);
    } else {
      // al editar los campos, validar que sean distintos para ocupar el servicio
      if (this.mObjCRUDCatalogos.validarSiCambioCamposCatalogos(newValor, oldValor, EnumTresPuntos.Region)) {
        await this.agregarModificarRegion(newValor, oldValor, region.isAddRow);
      }
    }
  }

  private async agregarModificarRegion(newRegion: ClsRegion, oldRegion: ClsRegion, isAddRow: boolean) {
    const objCatalogo: ClsRegion = new ClsRegion();
    try {
      objCatalogo.Region = newRegion.Region.toUpperCase();
      objCatalogo.DescripcionRegion = newRegion.DescripcionRegion;
      this.tipoMsg.mostrarWaitDialog(isAddRow ? 'MENSAJES.WAIT.GUARDANDO_CATALOGO' : 'MENSAJES.WAIT.MODIFICANDO_CATALOGO');
      await this.mObjCRUDCatalogos.agregarModificarCatalogo([objCatalogo], 'RegionesRegistraActualiza2021');
      this.tipoMsg.mostrarToast(isAddRow ? 'MENSAJES.TOAS.GUARDANDO_CATALOGO' : 'MENSAJES.TOAS.MODIFICANDO_CATALOGO');
      this.tipoMsg.cerrarWaitDialog();
    } catch (e) {
      this.tipoMsg.cerrarWaitDialog();
      this.cancelarAddUpdateRegiones(newRegion, oldRegion, isAddRow);
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  // se ocupa cuando manda error al intentar agregar o modificar,
  // al agregar si manda error se quita la fila del grid
  // al editar si manda error se regresa a los valores anteriores
  private cancelarAddUpdateRegiones(newRegion: ClsRegion, oldRegion: ClsRegion, isAddRow: boolean) {
    if (isAddRow) {
      this.gridRegion.deleteRowById(newRegion.IdRegion);
    } else {
      this.gridRegion.updateRow(oldRegion, oldRegion.IdRegion);
    }
  }

  private async eliminarRegion(rowContext: RowType) {
    const region: ClsRegion = rowContext.data;
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.ELIMINANDO_CATALOGO', undefined, 'delete');
      await this.mObjCRUDCatalogos.eliminarCatalogo(region.Region, 'EliminarRegiones2021');
      this.gridRegion.getRowByIndex(rowContext.index).delete();
      this.tipoMsg.mostrarToast('MENSAJES.TOAS.ELIMINANDO_CATALOGO');
      this.tipoMsg.cerrarWaitDialog();
    } catch (e) {
      this.tipoMsg.cerrarWaitDialog();
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  // se ocupa el evento rowEdit para validar uno o varios campos obligatorios,
  // si falta algun campo de todo la fila se cancela la edicio y se manda mensaje que campos faltan
  // en caso de ser todo OK, procede al agregado o modificado
  public validarRegion(region: IGridEditEventArgs) {
    const valor: ClsRegion = region.newValue;
    region.cancel = this.esValido(valor.Region, region, region.isAddRow);
  }

  // en este caso se pasa el valor de la region, ya que es el unico campo obligatorio,
  // en caso de ser mas campos a validar, pasar toda la clase
  private esValido(valor: string, reg: any, isAddRow: boolean): boolean {
    // validar campos obligatorios
    if (ClsUtil.esNulo(valor)) {
      this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertValidarCampos(this.mObjGenerico.getTranslationValidarColuma('GRIDS.REGION.COL_REGION')));
      return true;
    }
    // valida si ya existe la empresa cuando se agrega o modifica
    if (isAddRow) {
      if (this.dataRegiones.findIndex(region => region.Region === valor) !== -1) {
        this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertRegistroExistente(valor));
        return true;
      }
    } else {
      if (valor !== reg.oldValue.Region) {
        if (this.dataRegiones.findIndex(region => region.Region === valor) !== -1) {
          this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertRegistroExistente(valor));
          return true;
        }
      }
    }
    return false;
  }

  public async onSelectionDropDown(opcion: string) {
    try {
      switch (opcion) {
        case EnumMasOpciones.Ajustar:
          const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
          this.themesClass = result.themesClass;
          this.clicked = result.clicked;
          break;
        case EnumMasOpciones.ExportarExcel:
          const sms = await ClsUtil.exportarDatos(this.gridRegion, this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.REGIONES'), this.excelExportService).then(sms => { return sms });
          this.tipoMsg.mostrarToast(this.mObjGenerico.getTranslationsSmsExportar(sms, this.gridRegion.selectedRows.length));
          break;
        case EnumMasOpciones.ExportarPDF:
          await ClsUtil.abrirVentanaPersonalizarPDF(
            this.gridRegion,
            this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.REGIONES'),
            this.pdfExportService,
            this.crearCompDinamico,
            this.tipoMsg,
            this.mObjGenerico
          );
          break;
        case EnumMasOpciones.Actualizar:
          await this.cargarRegiones();
          break;
        case EnumMasOpciones.LimpiarFiltroColumnas:
          this.clearInput();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public async accionSeleccionada(evt: INeodataGridCell) {
    try {
      switch (evt.accionMenu.id) {
        case EnumMCGenerales.Copiar:
          await this.copiarData();
          break;
        case EnumMCGenerales.Pegar:
          let data: any = await navigator.clipboard.readText().then((data2) => data2);
          data = this.pasteHandlerNeo.processData(data);
          await this.datosPegadosDesdeExcel(data);
          break;
        case EnumMasOpciones.Ajustar:
          const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
          this.themesClass = result.themesClass;
          this.clicked = result.clicked;
          break;
        case EnumMCGenerales.GuardarLayout:
          const state = this.state.getState(true);
          this.mObjConfigGrids.saveGridState(EnumNombresGrids.Regiones, false, '', state, !this.clicked);
          break;
        case EnumMCGenerales.ReestablecerLayout:
          this.restoreGrid();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public restoreGrid() {
    const stateDefault = this.mObjConfigGrids.restoreGrid(EnumNombresGrids.Regiones);
    if (!ClsUtil.esNulo(stateDefault[0])) {
      this.state.setState(stateDefault[0]);
    }
    this.clicked = stateDefault[1];
    const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
    this.themesClass = result.themesClass;
    this.clicked = result.clicked;
  }

  public clearInput() {
    this.filtroGeneral.input.value = '';
    this.gridRegion.clearFilter();
  }

  public filterInput(filtro: string) {
    this.gridRegion.filteringLogic = FilteringLogic.Or;
    this.gridRegion.filterGlobal(filtro, IgxStringFilteringOperand.instance().condition('contains'));
  }

  public menuContextual(evt: any) {
    evt.event.preventDefault();
    this.disableContextMenu();
    this.disableAllContextMenu();
    this.menus = this.mObjCRUDCatalogos.crearMenuContextual({
      esCliente: false,
      esUnidad: false,
      esEmpresa: false
    }, this.infPpto.esPptoMaestro);
    this.subMenusOpciones = [];
    this.lengthMenu = this.menus.filter(x => !x.disabled).length;
    this.contextmenuX = ClsUtil.calcPosition(document.body.clientWidth, evt.event.clientX, true, this.lengthMenu);
    this.contextmenuY = ClsUtil.calcPosition(document.body.clientHeight, evt.event.clientY, false, this.lengthMenu);
    this.sizeMenu = (this.lengthMenu * 37) + 'px';
    this.cellMenuContextaul = evt.cell;
    this.verContextMenu = true;
  }

  public disableContextMenu() {
    if (this.verContextMenu) {
      this.verContextMenu = false;
    }
  }

  public disableAllContextMenu() {
    this.mObjGenerico.disableAllContextMenu(this.infPpto);
  }

  public accionStripRowBtn(rowContext: RowType, indexBtn: number) {
    try {
      switch (indexBtn) {
        case 1:
          this.beginAddRowByIndexNeo(this.gridRegion, rowContext.index);
          break;
        case 2:
          this.tipoMsg.mostrarQuestion(async (resp: boolean) => {
            if (resp) {
              await this.eliminarRegion(rowContext);
            }
          }, this.mObjGenerico.getTranslationsQuestionBorrar(rowContext.data.Region));
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public handleRowSelection() {
    this.gridRegion.nativeElement.focus();
  }

  public async datosPegadosDesdeExcel(datosPegado: any[]) {
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.PEGANDO');
      const arrayRegiones: ClsRegion[] = [];
      const colReg: string = this.mObjGenerico.getTranslationsSubject('GRIDS.REGION.COL_REGION');
      const colDes: string = this.mObjGenerico.getTranslationsSubject('GRIDS.REGION.COL_DESCRIPCION');
      let dataDetalle: ClsColDetallePegado[];
      this.mObjCopiado.columnasRequeridas = [colReg];
      if (this.mObjCopiado.validarCamposRequeridos(datosPegado)) {
        let datos = this.mObjCopiado.procesarDatos(datosPegado, true);
        datos = this.mObjPegado.mergeDescriptions(datos, EnumNombresGrids.Regiones);
        dataDetalle = this.mObjPegado.verificarDetallePegado(datos, [colReg, colDes], [colReg], EnumNombresGrids.Regiones, this.mObjGenerico);
        if (dataDetalle.length > 0) {
          const vtnGenerico = this.crearCompDinamico.crearComponente(VtnGenericaComponent).instance as VtnGenericaComponent;
          vtnGenerico.queVtnEstaAbierta = 'PegadoEspecial';
          const vtnDiferencia = vtnGenerico.crearComponente(DetallePegadoComponent);
          vtnDiferencia.dataDetalle = dataDetalle;
          vtnDiferencia.open();
        } else {
          datos.forEach(x => {
            const valReg: string = (x[colReg] as string).toUpperCase();
            // const valDes1: string = !ClsUtil.esNulo(x[colDes]) ? x[colDes].substring(0, 40) : x[colDes];
            const valDes: string = ClsUtil.toSubstring(x[colDes], 40);
            const resp: any = this.mObjCRUDCatalogos.crearObjCatalogos(this.dataRegiones, [valReg, valDes], [colReg, colDes], EnumTresPuntos.Region, this.mObjGenerico);
            // si esNuevo es undifined, indica que existe pero no cambio nada
            if (!ClsUtil.esNulo(resp.esNuevo)) {
              if (resp.esNuevo) {
                this.gridRegion.addRow(resp.obj);
                arrayRegiones.push(resp.obj);
              } else {
                this.gridRegion.updateCell(valDes, valReg, 'DescripcionRegion');
                arrayRegiones.push(resp.obj);
              }
            }
          });
          // invocar servicio para agregar o modificar siempre y cuando el arrayRegiones tenga valor
          if (arrayRegiones.length > 0) {
            await this.mObjCRUDCatalogos.agregarModificarCatalogo(arrayRegiones, 'RegionesRegistraActualiza2021');
            this.tipoMsg.mostrarToast(this.mObjGenerico.getTranslationsSubject('MENSAJES.TOAS.REGISTROS_PEGADOS').replace('{0}', arrayRegiones.length.toString()));
          }
        }
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message);
    } finally {
      this.tipoMsg.cerrarWaitDialog();
    }
  }

  public async customKeydown(eventArgs) {
    const ctrl = eventArgs.ctrlKey;
    const key = eventArgs.keyCode;
    // Ctrl-C ||  Cmd-C
    if ((ctrl || eventArgs.metaKey) && key === 67) {
      await this.copiarData();
    }
  }

  public async copiarData() {
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.COPIANDO');
      const msg: string = await ClsUtil.copiarDatosGrids(this.gridRegion, 'IdRegion', this.mObjGenerico);
      msg && this.tipoMsg.mostrarToast(msg);
    } catch (e) {
      throw new Error(e.message);
    } finally {
      this.tipoMsg.cerrarWaitDialog();
    }
  }

  public clearProps() {
    this.gridRegion.clearSort();
    this.gridRegion.clearFilter();
    this.gridRegion.clearSearch();
    this.gridRegion.deselectAllRows();
    this.clearInput();
  }

  public registroSeleccionado() {
    const rowSeleccionados: bigint[] = this.gridRegion.selectedRows;
    try {
      if (rowSeleccionados.length === 0) {
        throw new Error('MENSAJES.ALERT.SELECCIONAR_REGISTRO');
      }
      const rowData = this.gridRegion.getRowData(rowSeleccionados[0]);
      this.gridRegion.doubleClick.emit(rowData);
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }
}
